export const SEARCH_START = 'SEARCH_START';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_FAILURE = 'SEARCH_FAILURE';

export const CLEAR_ERROR_RULE = 'CLEAR_ERROR_RULE';
export const CREATE_START = 'CREATE_START';
export const CREATE_SUCCESS = 'CREATE_SUCCESS';
export const CREATE_FAILURE = 'CREATE_FAILURE';

export const SHOW_START = 'SHOW_START';
export const SHOW_SUCCESS = 'SHOW_SUCCESS';
export const SHOW_FAILURE = 'SHOW_FAILURE';

export const UPDATE_START = 'UPDATE_START';
export const UPDATE_SUCCESS = 'UPDATE_SUCCESS';
export const UPDATE_FAILURE = 'UPDATE_FAILURE';

export const DESTROY_START = 'DESTROY_START';
export const DESTROY_SUCCESS = 'DESTROY_SUCCESS';
export const DESTROY_FAILURE = 'DESTROY_FAILURE';

export const CSV_OUTPUT_START = 'CSV_OUTPUT_START';
export const CSV_OUTPUT_SUCCESS = 'CSV_OUTPUT_SUCCESS';
export const CSV_OUTPUT_FAILURE = 'CSV_OUTPUT_FAILURE';

export const CLEAR_ALL = 'CLEAR_ALL';

export const FATAL_FAILURE = 'SYSTEM_FAILURE';
